module.exports = __webpack_public_path__ + "static/media/Conga_Wordmark_Purple_Login.6048de48.svg";